import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout";
import Container from "../../components/Container";
import Content from "../../components/Content";
import { useAuthState, requiresClient } from "../../components/AuthProvider";
import Flex from "../../components/Flex";
import DefaultBreadcrumbs from "../../components/DefaultBreadcrumbs";
import DataTable from "../../components/DataTable";
import { useHistory } from "react-router-dom";
import ButtonList from "../../components/ButtonList";
import LinkButton from "../../components/LinkButton";
import FlickerText from "../../components/FlickerText";
import dateTimeDiff from "./dateTimeDiff";
import task_type_dict from "./taskTypes";

import styles from "./Tasks.module.scss";
import Spinner from "../../components/Loader/Spinner";

const Tasks = () => {
  // TODO this functionality has been unused and is deprecated
  const clientConfigApiDomain = process.env.REACT_APP_CLIENT_CONFIG_API_V1_DOMAIN;
  const batchLoadsRpcUrl = `${clientConfigApiDomain}/rpc/batchloads`;

  const { user } = useAuthState();
  const history = useHistory();

  const [dataLoadsData, setDataLoadsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchDataLoads = async () => {
      const fetchDataLoadResponse = await fetch(
        `${batchLoadsRpcUrl}/?client_oid=${user.preferences.selectedClient.oid}`
      );
      const fetchDataLoadResponseData = await fetchDataLoadResponse.json();

      if (fetchDataLoadResponseData.hasOwnProperty("results")) {
        setDataLoadsData(fetchDataLoadResponseData.results);
      }
    };

    setIsLoading(true);
    fetchDataLoads().then(() => {
      setIsLoading(false);
    });
  }, [batchLoadsRpcUrl, user.preferences.selectedClient.oid]);

  const actionCell = ({
    cell: {
      value,
      row: { original: selectedDataLoad }
    }
  }) => {
    const onDetailsClick = () => {
      history.push(`/tasks/${selectedDataLoad.task_id}`);
    };

    const onRerunClick = () => {
      history.push(`/tasks/${selectedDataLoad.task_id}/rerun`);
    };

    return (
      <ButtonList className={styles.icons}>
        <LinkButton icon="view" onClick={onDetailsClick}>
          Details
        </LinkButton>
        <LinkButton icon="redo" onClick={onRerunClick}>
          Rerun
        </LinkButton>
      </ButtonList>
    );
  };

  const clickableCell = ({
    cell: {
      value,
      row: { original: selectedDataLoad }
    }
  }) => {
    const onViewClick = () => {
      history.push(`/tasks/${selectedDataLoad.task_id}`);
    };

    return (
      <span className={styles.cell} onClick={onViewClick}>
        {selectedDataLoad.task_id}
      </span>
    );
  };

  function formattedTimeDiff(to, from) {
    return dateTimeDiff(
      new Date(to.replace(" ", "T")),
      new Date(from.replace(" ", "T"))
    );
  }

  const columns = [
    {
      Header: "ID",
      accessor: "task_id",
      Cell: clickableCell,
      canSort: false
    },
    {
      Header: "Type",
      accessor: row =>
        task_type_dict.hasOwnProperty(row.task_name)
          ? task_type_dict[row.task_name]
          : row.task_name
    },
    {
      Header: "Runtime",
      accessor: row => (
        <>
          {row.date_done === "NOT_AVAILABLE" ||
          row.date_started === "NOT_AVAILABLE"
            ? "-"
            : formattedTimeDiff(row.date_done, row.date_started)}
        </>
      )
    },
    {
      Header: "Instances",
      accessor: row =>
        row.task_kwargs.master_instance_count
          ? row.task_kwargs.master_instance_count +
            " Master Node(s) " +
            row.task_kwargs.slave_instance_count +
            " Slave Node(s)"
          : "-"
    },
    {
      Header: "Status",
      accessor: row => (
        <>
          {row.status === "SUCCESSFUL" ||
          row.status === "ERROR" ||
          row.status === "FAILED" ? (
            row.status
          ) : (
            <FlickerText text={row.status} />
          )}
        </>
      )
    },
    {
      Header: "",
      accessor: "actions",
      disableFilters: true,
      disableSortBy: true,
      Cell: actionCell
    }
  ];

  return (
    <Layout>
      <Container>
        <Flex gutter={3}>
          <Flex.Item span={12}>
            <DefaultBreadcrumbs />
          </Flex.Item>
          {isLoading ? (
            <Spinner />
          ) : (
            <Flex.Item span={12}>
              <Content>
                <h1>Tasks</h1>
              </Content>
              <div className={styles.base}>
                <ButtonList spacing={2} style={{ margin: "1rem 0" }}>
                  <LinkButton
                    icon="add"
                    onClick={() => {
                      history.push("/tasks/start");
                    }}
                  >
                    Start Task
                  </LinkButton>
                </ButtonList>
                <div>
                  <DataTable
                    columns={columns}
                    data={dataLoadsData}
                    hasPagination
                  />
                </div>
              </div>
            </Flex.Item>
          )}
        </Flex>
      </Container>
    </Layout>
  );
};

export default requiresClient(Tasks);
